import _ from 'underscore';

export function anyChecked(checkboxes){
    return _(checkboxes.toArray()).any((item) => {
      return $(item).is(":checked");
    });
}


// WEBPACK FOOTER //
// ./src/pages/createChannel/utilities.js